<template>
    <div class="list-notes" :class="[scrollbarClass, { 'no-scroll': !expandedSectionNav }]">
        <CommentInput
            ref="commentInput"
            :currentUser="currentUser"
            :loading="loadingSend"
            @submit="newComment(null, $event)"
        />
        <CommentCard
            v-for="comment in comments"
            :key="comment._id || comment.date"
            :comment="comment"
        />
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import postMixin from '@/components/mixins/Posts.vue'
import accessibilityMixin from '@/components/mixins/Accessibility.vue'
import CommentInput from './CommentInput.vue'
import CommentCard from './CommentCard.vue'

export default {
    components: { CommentInput, CommentCard },

    mixins: [postMixin, accessibilityMixin],

    props: {
        comments: { type: Array, default: () => [] },
        currentUser: { type: Object, required: true },
        expandedSectionNav: { type: Boolean, default: false },
        event: { type: Object, required: true },
    },

    data() {
        return {
            loadingSend: false,
        }
    },

    methods: {
        async newComment(all = null, { message, files } = {}) {
            if (this.loadingSend) return

            if (all == null) {
                if (this.isPostsMultipaged(this.event.originalPost)) {
                    EventBus.$emit("showModal",
                        this.$t('dash.posts.multi-pages.add_note.title'),
                        this.$t('dash.posts.multi-pages.add_note.body'),
                        this.$t('dash.posts.drawer.all-posts'),
                        this.$t('dash.posts.drawer.this-post-only'),
                        () => { this.newComment(true, { message, files }) },
                        () => { this.newComment(false, { message, files }) },
                    );
                    return
                } else {
                    all = false
                }
            }

            this.loadingSend = true
            let mediasUpload = []

            for (const file of files) {
                const { file_url } = await this.uploadFile(file.url)
                mediasUpload.push({ url: file_url, type: file.type })
            }

            const comment = {
                date: new Date().toISOString(),
                message,
                name: !localStorage.supervisor ? `${this.currentUser.lastname} ${this.currentUser.firstname}` : 'Mashup Web Social',
                email: !localStorage.supervisor ? this.currentUser.email : 'contact@mashup-web.com',
                mediasUpload,
            }

            try {
                const { body } = await this.addCommentPost(this.event.originalPost, comment, all)
                if (body.success) {
                    this.$refs.commentInput.reset()
                    this.$set(this.event, 'originalPost', { ...this.event.originalPost, ...body.post })
                    this.$emit('comment-added')
                }
            } catch (error) {
                console.error(error)
            }

            this.loadingSend = false
        },

        async uploadFile(file) {
            const { VUE_APP_API_HOST } = process.env

            if (typeof file === "string" && file.startsWith("blob:")) {
                const response = await fetch(file)
                const blob = await response.blob()
                file = new File([blob], "uploaded-file", { type: blob.type })
            }

            let formData = new FormData()
            formData.append('file', file)

            const { body } = await this.$http.post(`${VUE_APP_API_HOST}/posts/upload/file`, formData)
            return body
        },
    },
}
</script>
